import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Field } from 'redux-form';
import { FormattedMessage, defineMessages, intlShape } from 'react-intl';
import { isEmpty } from 'helpers/verify';
import { InputField, LocationInputField } from 'components/FormFields';
import { CTA_COLOR_BY_NAME } from 'constants/colors';
import { CODE_BY_ERROR as CODE_BY_LEAD_GEN_ERROR } from './LeadGenForm.saga';
var messages = defineMessages({
  email: {
    id: 'leadgen.email',
    defaultMessage: 'Email address'
  },
  location: {
    id: 'leadgen.location',
    defaultMessage: 'City name'
  }
});
export var LeadGenForm =
/*#__PURE__*/
function (_Component) {
  _inherits(LeadGenForm, _Component);

  function LeadGenForm() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LeadGenForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LeadGenForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (_ref) {
      var email = _ref.email,
          location = _ref.location;
      var _this$props = _this.props,
          onWaitlistRequest = _this$props.onWaitlistRequest,
          submissionType = _this$props.submissionType;
      onWaitlistRequest({
        email: email,
        submissionType: submissionType,
        location: location
      });
    });

    return _this;
  }

  _createClass(LeadGenForm, [{
    key: "renderError",
    value: function renderError() {
      var error = this.props.formError || {};
      var errorMessage;

      if (typeof error === 'string') {
        errorMessage = error;
      } else if (error.code === CODE_BY_LEAD_GEN_ERROR.ALREADY_ON_WAITLIST) {
        errorMessage = React.createElement(FormattedMessage, {
          id: "leadgen.existingLead",
          defaultMessage: "We love your enthusiasm \u2014 don\u2019t worry, you\u2019re already on the list!"
        });
      } else if (error.code === CODE_BY_LEAD_GEN_ERROR.ALREADY_MEMBER) {
        errorMessage = React.createElement(FormattedMessage, {
          id: "leadgen.existingAccount",
          defaultMessage: "Oops! This email is already associated with a ClassPass account. {link}.",
          values: {
            link: React.createElement(Link, {
              to: "/login",
              target: "_self"
            }, "Sign in")
          }
        });
      } else if (error.defaultMessage) {
        errorMessage = React.createElement(FormattedMessage, error);
      } else if (!isEmpty(error)) {
        errorMessage = React.createElement(FormattedMessage, {
          id: "leadgen.defaultError",
          defaultMessage: "Something isn\u2019t working out right now.  Sit tight \u2013 we should be up and running shortly."
        });
      }

      if (errorMessage) {
        return React.createElement("p", {
          className: "lead-gen-form__error"
        }, errorMessage);
      }
    }
  }, {
    key: "renderSuccess",
    value: function renderSuccess() {
      return React.createElement("p", {
        className: "lead-gen-form__success"
      }, React.createElement(FormattedMessage, {
        id: "leadgen.thanks",
        defaultMessage: "Thanks! You\u2019re officially on the list."
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          ctaCopy = _this$props2.ctaCopy,
          handleSubmit = _this$props2.handleSubmit,
          hideLocation = _this$props2.hideLocation,
          _this$props2$singleLi = _this$props2.singleLineBreakpoint,
          singleLineBreakpoint = _this$props2$singleLi === void 0 ? 'md' : _this$props2$singleLi,
          wasCaptured = _this$props2.wasCaptured,
          intl = _this$props2.intl;
      return React.createElement("div", {
        className: "lead-gen-form"
      }, React.createElement("form", {
        method: "post",
        onSubmit: handleSubmit(this.handleSubmit)
      }, React.createElement("div", {
        className: "grid"
      }, React.createElement("div", {
        className: "grid__item ".concat(singleLineBreakpoint, "-2/5 pb-")
      }, React.createElement(Field, {
        component: InputField,
        name: "email",
        suppressErrorMessage: true,
        inputAttributes: {
          disabled: wasCaptured,
          placeholder: intl.formatMessage(messages.email)
        }
      })), !hideLocation && React.createElement("div", {
        className: "grid__item ".concat(singleLineBreakpoint, "-2/5 ").concat(singleLineBreakpoint, "-pl pb")
      }, React.createElement(Field, {
        component: LocationInputField,
        format: null,
        name: "location",
        suppressErrorMessage: true,
        inputAttributes: {
          disabled: wasCaptured,
          placeholder: intl.formatMessage(messages.location)
        }
      })), React.createElement("div", {
        className: "grid__item ".concat(singleLineBreakpoint, "-1/5 ").concat(singleLineBreakpoint, "-pl")
      }, React.createElement("button", {
        type: "submit",
        className: "".concat(CTA_COLOR_BY_NAME.primary_solid, " bt--width-full"),
        disabled: wasCaptured
      }, ctaCopy || React.createElement(FormattedMessage, {
        id: "leadgen.submit",
        defaultMessage: "Submit"
      }))))), wasCaptured ? this.renderSuccess() : this.renderError());
    }
  }]);

  return LeadGenForm;
}(Component);
LeadGenForm.propTypes = {
  intl: intlShape.isRequired,
  ctaCopy: PropTypes.string,
  formError: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleSubmit: PropTypes.func.isRequired,
  hideLocation: PropTypes.bool,
  submissionType: PropTypes.string,
  onWaitlistRequest: PropTypes.func.isRequired,
  singleLineBreakpoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'retina', 'none']),
  wasCaptured: PropTypes.bool
};